"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculateWeekDays = calculateWeekDays;
const WEEK_IN_MS = 1000 * 60 * 60 * 24 * 7;
function calculateWeekDays(d1, d2) {
    const d1WeekStart = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate() - d1.getDay());
    const d2WeekStart = new Date(d2.getFullYear(), d2.getMonth(), d2.getDate() - d2.getDay());
    const weeks = (d2WeekStart.getTime() - d1WeekStart.getTime()) / WEEK_IN_MS;
    const d1Days = Math.min(Math.max(d1.getDay() - 1, 0), 5);
    const d2Days = Math.min(d2.getDay(), 5);
    return Math.round(weeks * 5 - d1Days + d2Days);
}
//# sourceMappingURL=WeekdayCalculator.js.map